import { parse } from "node-html-parser"

export default function BlogPostTransformer(
  html,
  props = {},
  unsafeDisplay = true
) {
  const headingsTree = []

  if (!html) return { headings: headingsTree, body: html }

  const root = parse(html.replace(/[\r\n]/gm, ""))
  if (!root.childNodes) return { headings: headingsTree, body: html }
  // console.log("root.childNodes", root.childNodes)

  const headingHtmlElements = root.childNodes.filter(
    node =>
      node.rawTagName === "h2" ||
      node.rawTagName === "h3" ||
      node.rawTagName === "h4"
  )
  if (!headingHtmlElements.length) return { headings: headingsTree, body: html }
  // console.log("headingHtmlElements", headingHtmlElements)

  const headingElemsCounter = {
    h2: 0,
    h3: 0,
    h4: 0,
  }
  headingHtmlElements.forEach(node => {
    const level = node.rawTagName.slice(-1)
    node.classList.add(`post-side-nav-heading${level}`)

    const id = `cpsnh${level}-${headingElemsCounter[node.rawTagName]++}`
    const wrapper = parse(`<a id="${id}" class="cpsnh-anchor"></a>`).firstChild
    wrapper.appendChild(node.clone(true))

    node.replaceWith(wrapper)

    headingsTree.push({ level: level, id: id, text: node.text })
  })
  // console.log("headingHtmlElements", headingHtmlElements)
  // console.log("headingsTree", headingsTree)
  // console.log("root", root.outerHTML)

  return { headings: headingsTree, body: root.outerHTML }
}
